<template>
    <section class="explore-models-section">
        <div class="container">
            <div class="section-header">
                <h2 class="section-title">{{ title }}</h2>
            </div>

            <div class="models-grid">
                <NuxtLink
                    v-for="(model, index) in models"
                    :key="index"
                    :to="model.path"
                    class="model-card"
                >
                    <div class="model-icon">
                        <img :src="model.icon" :alt="model.title" loading="lazy" />
                    </div>
                    <h3 class="model-card-title">{{ model.title }}</h3>
                </NuxtLink>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
interface Model {
    title: string
    icon: string
    path: string
}

interface Props {
    title: string
    models: Model[]
}

defineProps<Props>()
</script>

<style lang="less" scoped>
.explore-models-section {
    padding: 6rem 0;
    background-color: #0d0e12;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.section-header {
    text-align: center;
    margin-bottom: 3rem;
}

.section-title {
    font-size: 3.75rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: white;
    line-height: 1.2;
}

.models-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
}

.model-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 1.25rem 1.875rem;
    text-decoration: none;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 1rem;
    text-align: left;
    justify-content: flex-start;
    position: relative;

    &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.2);
        transform: translateY(-4px);
    }
}

.model-icon {
    width: 4rem;
    height: 4rem;
    flex-shrink: 0;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;

    img {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: contain;
    }
}

.model-card-title {
    font-size: 1rem;
    font-weight: 400;
    color: white;
    line-height: 1.4;
    margin: 0;
}

@media (max-width: 768px) {
    .explore-models-section {
        padding: 4rem 0;
    }

    .section-title {
        font-size: 2rem;
        padding: 0 1rem;
    }

    .section-header {
        margin-bottom: 2rem;
        padding: 0 1rem;
    }

    .models-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 0 1rem;
    }

    .model-card {
        padding: 1rem 1.5rem;
    }
}

@media (max-width: 480px) {
    .explore-models-section {
        padding: 3rem 0;
    }

    .section-title {
        font-size: 1.5rem;
    }

    .section-header {
        margin-bottom: 1.5rem;
    }
}
</style>

